import { render, staticRenderFns } from "./DarkText.vue?vue&type=template&id=784a2824&scoped=true&lang=pug"
import script from "./DarkText.vue?vue&type=script&lang=js"
export * from "./DarkText.vue?vue&type=script&lang=js"
import style0 from "./DarkText.styl?vue&type=style&index=0&id=784a2824&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784a2824",
  null
  
)

export default component.exports